import React from 'react'
import classnames from 'classnames'

const Entities = require('html-entities').XmlEntities
const entities = new Entities()

function limitWords(text, limit) {
  text = text
          .split(' ', limit).join(' ')
          .split('.').slice(0,-1).join('.')

  return text + '.'
}

const Commentary = ({
  overs = [],
  commentPreText = '',
  showCommentPreText = false
}) => {
  commentPreText = commentPreText && entities
                    .decode(limitWords(commentPreText, 100))
                    .replace(new RegExp('<br>', 'g'),'')
                    .replace(/\n\n/gm, '</p><p>')

  const commentary = (
    <div className="cricinfo__content__item">
      <h2 className="cricinfo__sub-title">Commentary</h2>
      <div className="cricinfo__content__detail">
        { showCommentPreText && commentPreText &&
          <div dangerouslySetInnerHTML={{ __html : `<p> ${commentPreText} </p>` }} />
        }
        {
          overs.map((o,i) => {
            const comms = (o.comments || []).map((c, i) => {
              const liClass = classnames('cricinfo__content__detail__list__item', {
                'cricinfo__content__detail__list__item--has-space': !commentPreText && (i > 0)
              })
              let textMarkup = entities.decode(c.text)
              let postText = c.post
              return (
                <li key={i} className={liClass}>
                  { postText &&
                    entities.decode(postText).split('\n\n').map((text, i) => {
                      let bKey = 'b' + i
                      return (
                        <div className="comment" key={bKey} dangerouslySetInnerHTML={{ __html: text }} />
                      )
                    }) || null
                  }
                  {
                    <span className="cricinfo__type__weight--bold">{c.timeStamp}</span>
                  }
                  {
                    <span dangerouslySetInnerHTML = {{ __html: textMarkup }}></span>
                  }
                </li>
              )
            })

            let overSummary = [
              o.endOfOver && <div className="cricinfo__endOfOver">End of over: {o.endOfOver}</div> || '',
              <ul className="cricinfo__content__detail__list">{comms}</ul>
            ]

            return overSummary
          })
        }
      </div>
    </div>
  )

  return overs.length || (overs.length === 0 && commentPreText) ? commentary : <div className="cricinfo__content__item" />
}

export default Commentary



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/lite/Commentary.jsx